const domReady = (callBack) => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callBack)
    } else {
        callBack()
    }
}

const windowReady = (callBack) => {
    if (document.readyState === 'complete') {
        callBack()
    } else {
        window.addEventListener('load', callBack)
    }
}

// Vanilla version of jQuery's .closest for classes
const getClosest = (elem, classes) => {
    for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.classList.contains(classes)) return elem
    }
    return null
}

const getOffset = (element) => {
    let rect = element.getBoundingClientRect()

    return {
        left: rect.left + window.scrollX,
        width: rect.width,
    }
}
